import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAwbInfo, getAwbObj, getBoxes, getOrders, intakeAWBReq, loadImage, saveBoxReq } from "../../../modules/StoresModule/Services/PackageIntakeService";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";
import { CountrySelectorDropdown } from "react-international-phone";

const newBox = (awb, awbId) => {
    console.warn('*new box parameters', awb, awbId);
    return ({ tempId: crypto.randomUUID(), id: null, awbNumberId: awbId ?? null, images: [], condition: "", imageFiles: [] })
};

export const packageIntakeSlice = createSlice({
    name: "packageIntake",
    initialState: {
        awbNumbers: [],
        // awbNumbers: ["1234ABCD", "000035545620", "810355022387", "992921", "8690504135708"],
        orders: {},
        boxes: {},
        vwNumber: "",
        awbIds: {},
        loading: {},
        awbInfo: {}
    },
    reducers: {
        addAwbNumber: (state, action) => {
            return { ...state, awbNumbers: [...state.awbNumbers, action.payload] }
        },
        addAwbBatch: (state, action) => {
            return { ...state, awbNumbers: [...state.awbNumbers, ...action.payload] }
        },
        loadingChange: (state, action) => {
            let { awb, loading } = action.payload;
            return { ...state, loading: { ...state.loading, [awb]: loading } };
        },
        batchLoadingChange: (state, action) => {
            let { awbs, loading } = action.payload;
            return { ...state, loading: { ...state.loading, ...Object.fromEntries(awbs.map(awb => [awb, loading])) } };
        },
        selectAWB: (state, action) => ({ ...state, vwNumber: action.payload }),
        addBox: (state, action) => {

            let { awb, awbId } = action.payload;
            console.warn('*action payload new box', awb, awbId);
            return Boolean(awb) ? { ...state, boxes: { ...state.boxes, [awb]: [...(state.boxes[awb] ?? []), newBox(awb, awbId)] } } : { ...state }
        },
        boxChange: (state, action) => {
            let { awb, idx, name, value } = action.payload;
            console.warn('*boxes change', awb, idx, name, value);
            let copy = [...state.boxes[awb]];
            copy[idx] = { ...copy[idx], [name]: value };
            return {
                ...state,
                boxes: { ...state.boxes, [awb]: copy }
            }
        },
        removeAwb: (state, action) => {
            let { awb } = action.payload;
            return { ...state, vwNumber: "", awbNumbers: [...state.awbNumbers.filter(qawb => !(awb === qawb))] }

        },
        resetPackageIntake: (state, action) => {
            return {
                awbNumbers: [],
                // awbNumbers: ["1234ABCD", "000035545620", "810355022387", "992921", "8690504135708"],
                orders: {},
                boxes: {},
                vwNumber: "",
                awbIds: {},
                loading: {},
                awbInfo: {}
            }
        }

    },
    extraReducers: (builder) => {
        builder.addCase(fetchOrders.fulfilled, (state, action) => {
            let { load, awb } = action.payload;
            console.warn('*load', load);
            let idsCopy = load.length > 0 ? { ...state.awbIds, [awb]: load[0].id } : { ...state.awbIds };

            return {
                ...state,
                vwNumber: awb,
                orders: { ...state.orders, [awb]: load },
                // boxes: { ...state.boxes, [awb]: [] },
                awbIds: idsCopy
            }
        });
        builder.addCase(saveBox.fulfilled, (state, action) => {
            let { box, awb, idx } = action.payload;
            let copy = [...state.boxes[awb]];
            copy[idx] = box;
            return {
                ...state,
                boxes: { ...state.boxes, [awb]: copy }
            }
        });
        builder.addCase(intakeAWB.fulfilled, (state, action) => {
            let { awb } = action.payload;
            return { ...state, vwNumber: "", awbNumbers: [...state.awbNumbers.filter(qawb => !(awb === qawb))] }
        });
        builder.addCase(fetchAwbInfo.fulfilled, (state, action) => {
            let { awbReduced } = action.payload;
            return { ...state, awbInfo: { ...state.awbInfo, ...awbReduced } }
        });
        builder.addCase(fetchBoxes.fulfilled, (state, action) => {
            let { awb, boxesList } = action.payload;
            // let boxesAux = [
            //     {
            //         "version": 0,
            //         "id": 17,
            //         "awbNumberId": 12,
            //         "condition": "crushed",
            //         "images": null,
            //         "tempId": "5e510989-b04a-4a72-9f91-b0bec56bb374"
            //     },
            //     {
            //         "version": 0,
            //         "id": 18,
            //         "awbNumberId": 12,
            //         "condition": "crushed",
            //         "images": null,
            //         "tempId": "51964380-ad2b-473a-bbb0-7bda271295bf"
            //     }
            // ];
            console.warn('*payload', awb, boxesList);
            return { ...state, boxes: { ...state.boxes, [awb]: boxesList } }
        });

        builder.addCase(reloadImages.fulfilled, (state, action) => {
            let {imageFiles, awb, boxIdx} = action.payload;
            console.warn('*boxes images fullfiled', imageFiles, awb, boxIdx);
            let copy = [...(state.boxes[awb] ?? [])];
            copy[boxIdx] = {...copy[boxIdx], imageFiles};
            return {...state, boxes: {...state.boxes, [awb]: copy}};
        })

    }
});

const defaultAWB = (awb) => ({ id: null, orders: 0, awbNumber: awb, status: "" })

export const fetchAwbInfo = createAsyncThunk("/packageIntake/fetchAwbInfo",
    async ({ awbList }, { rejectWithValue, getState }) => {
        let response = await getAwbInfo(awbList);
        console.warn('*awb-info', awbList, response);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            console.warn('response success', awbList.reduce((prev, curr) => ({ ...prev, [curr]: response.data.load.find(awbObj => awbObj.awbNumber === curr) ?? defaultAWB(curr) }), {}));
            let reducedAwbInfo = awbList.reduce((prev, curr) => ({ ...prev, [curr]: response.data.load.find(awbObj => awbObj.awbNumber === curr) ?? defaultAWB(curr) }), {});
            console.warn('awbReducedInfo', reducedAwbInfo);
            return { awbReduced: reducedAwbInfo }
        } else {
            return rejectWithValue(null);
        }
    }
)

const mockImages = [
    {id: 17, numberBoxId:17, imageId: "e813b731-885f-4d33-a186-acec943b896b.jpg", version: 0}
]

export const fetchBoxes = createAsyncThunk("packageIntake/fetchBoxes",
    async ({ awbId, awb }, { rejectWithValue, getState }) => {
        console.warn('fetching boxes for', awb, "(", awbId,")");
        if (typeof(awbId) !== 'number') {
            return rejectWithValue(null);
        }
        let response = await getBoxes(awbId);
        console.warn('*response-boxes', response);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            response.data.load = response.data.load.map(b => ({...b}));
            return ({ awb, boxesList: response.data.load.map(b => ({ ...b, tempId: crypto.randomUUID() })) });
        } else {
            return rejectWithValue(null);
        }
    }
)

export const reloadImages = createAsyncThunk("packageIntake/reloadImages",
    async({awb, boxIdx, images}, {rejectWithValue, getState}) => {
        let responses = await Promise.all(images.map(img => loadImage(img.imageId)));
        console.warn('*reload images responses', responses);
        if (responses.every(r => r.status === 200) && responses.every(r => r.headers['content-type'].startsWith("image/"))) {
            console.warn("all responses valid");    
            return ({imageFiles: responses.map((r, j) =>  ({preview: r.data, file: {name: images[j].imageId}})
            ), awb, boxIdx})
        } else {
            console.warn("not all responses valid");    
            return rejectWithValue(null);
        }
    }
)



export const fetchOrders = createAsyncThunk("packageIntake/fetchOrders",
    async ({ awb }, { rejectWithValue, getState }) => {
        let response = await getOrders(awb);
        console.warn("response:36", response);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { load: response.data.load, awb };
        } else {
            return rejectWithValue(null);
        }
    }
)

export const saveBox = createAsyncThunk("packageIntake/saveBox",
    async ({ awb, awbId, idx, box }, { rejectWithValue, getState }) => {
        let newImages = box.imageFiles.filter(imgF => imgF.file instanceof File);
        let response = await saveBoxReq({...box, images:newImages}, awb, awbId);
        console.warn('*boxes response', response);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { box: { ...response.data.load, tempId: box.tempId, imageFiles: box.imageFiles }, awb, idx, respData: response.data };
        } else {
            return rejectWithValue(null);
        }
    }
)

export const intakeAWB = createAsyncThunk("packageIntake/intakeAwb",

    async ({ awb }, { rejectWithValue, getState }) => {
        let response0 = await getAwbObj(awb);
        console.warn('response0', response0);
        if (response0.data.responseCode === 200 && response0.data.load?.[0]) {
            let response = await intakeAWBReq({ ...response0.data.load[0], awbStatus: "package_in_take" });
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                return { awb, respData: response.data };
            } else {
                return rejectWithValue(null);
            }
        } else {
            return rejectWithValue(null);
        }

    }
)


export const selectAWBN = (state) => state.packageIntake.awbNumbers;
export const selectVwNumber = (state) => state.packageIntake.vwNumber;
export const selectOrders = (state) => state.packageIntake.orders;
export const selectBoxes = (state) => state.packageIntake.boxes;
export const selectAwbIds = (state) => state.packageIntake.awbIds;
export const selectLoading = (state) => state.packageIntake.loading;
export const selectAwbInfo = (state) => state.packageIntake.awbInfo;
export const { addAwbNumber, addAwbBatch, selectAWB, addBox, boxChange, resetPackageIntake, loadingChange, removeAwb, batchLoadingChange } = packageIntakeSlice.actions;
export default packageIntakeSlice.reducer;